import {Button, Group, Tooltip} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import {AddPickupButton} from 'src/work/add-pickup-button'

type OrderPlusButtonsProps = {
    projectId: string
    sourceJobId: string | null
    pickupFromJobId: string | null
}

const NEEDS_A_JOB = 'Add a delivery first'

export function OrderPlusButtons({projectId, sourceJobId, pickupFromJobId}: OrderPlusButtonsProps) {
    const from = sourceJobId ?? undefined
    return (
        <Group gap="xs" role="group" aria-label="Add to this order">
            <Button
                variant="default"
                renderRoot={(props) => (
                    <Link
                        {...props}
                        to="/projects/$projectId/jobs/add"
                        params={{projectId}}
                        search={{from}}
                    />
                )}
            >
                + Delivery
            </Button>
            <AddPickupButton projectId={projectId} fromJobId={pickupFromJobId} />
            {sourceJobId ? (
                <>
                    <Button
                        variant="default"
                        renderRoot={(props) => (
                            <Link
                                {...props}
                                to="/projects/$projectId/service-visits"
                                params={{projectId}}
                                search={{from: sourceJobId}}
                            />
                        )}
                    >
                        + Service visits
                    </Button>
                    <Button
                        variant="default"
                        renderRoot={(props) => (
                            <Link
                                {...props}
                                to="/projects/$projectId/more-sites"
                                params={{projectId}}
                                search={{from: sourceJobId}}
                            />
                        )}
                    >
                        + More sites
                    </Button>
                </>
            ) : (
                <>
                    <Tooltip label={NEEDS_A_JOB}>
                        <Button variant="default" disabled>
                            + Service visits
                        </Button>
                    </Tooltip>
                    <Tooltip label={NEEDS_A_JOB}>
                        <Button variant="default" disabled>
                            + More sites
                        </Button>
                    </Tooltip>
                </>
            )}
        </Group>
    )
}
